import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const StaffLoginAsModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "StaffLoginAsModalContainer" */
      './StaffLoginAsModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
